const common = {
    favoriteItems: "favorite-items",
    basketItems: "basket-items"
};

export { common };